import { render, staticRenderFns } from "./Common.vue?vue&type=template&id=78e4b394"
import script from "./Common.vue?vue&type=script&lang=ts"
export * from "./Common.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports